import { useTranslation } from 'react-i18next';

import { OpSection } from 'new-components/DLS/OpSection/OpSection';
import { OpText } from 'new-components/DLS/OpText/OpText';
import { opTime } from 'utils/dates';

import './releaseNote.scss';

interface ReleaseNoteProps {
  date: string;
  notes: {
    category: string;
    note: string;
    subNotes?: {
      subNote: string;
      subLink?: string;
    }[];
  }[];
}

export const ReleaseNote = ({ date, notes }: ReleaseNoteProps) => {
  const { t } = useTranslation();
  return (
    <OpSection className="release-note">
      <OpText className="release-note__date" fontWeight="700" size="large">
        {opTime(date).format('MMMM DD, YYYY')}
      </OpText>
      {notes.map((note) => (
        <div key={note.note}>
          <OpText size="regular">{note.note}</OpText>
          <div className="release-note__sub-notes">
            {note.subNotes?.map(({ subNote, subLink }) => (
              <OpText size="regular" key={subNote}>
                {subNote}
                {subLink && (
                  <a href={subLink} target="_blank" rel="noopener noreferrer">
                    {t(' [Click for more details.]')}
                  </a>
                )}
              </OpText>
            ))}
          </div>
        </div>
      ))}
    </OpSection>
  );
};
